export class AreaItem {
    name : string;
    order: number;
    date: Date;
    createdBy: string;
    modifiedBy: string;
}